<template>
  <div>
    <ItemHeader
      :title="`Доверенное лицо № ${v.number.$model}`"
      :expand="expand"
      :btn-delete-visible="canDelete"
      btn-delete-text="Удалить доверенное лицо"
      @btn-expand-click="expand = !expand"
      @btn-delete-click="$emit('delete')"
    />

    <v-expand-transition>
      <div v-show="expand">
        <div class="form-section-base__controls">
          <v-row>
            <v-col>
              <v-radio-group v-model="v.role.$model" row>
                <v-radio label="Физическое лицо" :value="Role.PERSON" />
                <v-radio label="Юридическое лицо" :value="Role.ORGANIZATION" />
                <v-radio
                  label="Иностранное юридическое лицо"
                  :value="Role.FOREIGN_ORGANIZATION"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </div>

        <ProxyPersonPerson v-if="v.role.$model === Role.PERSON" :v="v.person" />

        <ProxyPersonOrganization
          v-if="v.role.$model === Role.ORGANIZATION"
          :v="v.organization"
        />

        <ProxyPersonForeignOrganization
          v-if="v.role.$model === Role.FOREIGN_ORGANIZATION"
          :v="v.foreignOrganization"
        />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';

import { Role } from '@/utils/dictionaries';
import ItemHeader from '@/components/services/elements/ItemHeader';
import ProxyPersonPerson, {
  proxyPersonPersonModel,
  proxyPersonPersonValidation,
} from './ProxyPersonPerson';
import ProxyPersonOrganization, {
  proxyPersonOrganizationModel,
  proxyPersonOrganizationValidation,
} from './ProxyPersonOrganization';
import ProxyPersonForeignOrganization, {
  proxyPersonForeignOrganizationModel,
  proxyPersonForeignOrganizationValidation,
} from './ProxyPersonForeignOrganization';

export const proxyPersonModel = {
  role: Role.PERSON,
  number: 1,
  person: cloneDeep(proxyPersonPersonModel),
  organization: cloneDeep(proxyPersonOrganizationModel),
  foreignOrganization: cloneDeep(proxyPersonForeignOrganizationModel),
};

export const proxyPersonValidation = {
  role: {},
  number: {},
  person: proxyPersonPersonValidation,
  organization: proxyPersonOrganizationValidation,
  foreignOrganization: proxyPersonForeignOrganizationValidation,
};

export default {
  name: 'ProxyPerson',
  props: {
    v: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ItemHeader,
    ProxyPersonPerson,
    ProxyPersonOrganization,
    ProxyPersonForeignOrganization,
  },
  data: () => ({
    Role,
    role: Role.PERSON,
    expand: true,
  }),
};
</script>
